import { Component } from '@angular/core';
import { QSSimpleService } from './quickstart-simple.service';

@Component({
  template: "<router-outlet></router-outlet>",
  providers: [QSSimpleService]
})
export class QSSimpleComponent {

  constructor(private _service: QSSimpleService) { }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/quickstart-simple.component.ts